import { useState, useEffect } from 'react'
import { apiClient } from '../api/client'
import type { Album } from '../api/types'

type UseAlbumsResult = {
  albums: Album[]
  loading: boolean
  error: string | null
  refresh: () => void
}

/**
 * アルバム一覧を取得するカスタムフック
 */
export function useAlbums(startDate: string, endDate: string): UseAlbumsResult {
  const [albums, setAlbums] = useState<Album[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchAlbums = async () => {
    if (!startDate || !endDate) {
      setAlbums([])
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    try {
      const response = await apiClient.getAlbums({ startDate, endDate })
      setAlbums(response.albums)
    } catch (err) {
      console.error('Failed to fetch albums:', err)
      setError(err instanceof Error ? err.message : 'Failed to fetch albums')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAlbums()
  }, [startDate, endDate])

  return {
    albums,
    loading,
    error,
    refresh: fetchAlbums,
  }
}
